import InscricaoDesconto from "@/Models/Domain/Viagem/Inscricao/InscricaoDesconto";
import { AxiosResponse } from "axios";
import { ReactElement, useRef } from "react";
import InscricaoDescontoFormBasic, { IInscricaoDescontoFormBasicRef, IInscricaoDescontoFormBasicProps } from "./InscricaoDescontoFormBasic";
import { Button, Divider, Flex, notification } from "antd";
import { useInscricaoDescontoSalvar } from "@/Services/Domain/Viagem/Inscricao/InscricaoDescontoService";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";

export interface IInscricaoDescontoFormProps extends Omit<IInscricaoDescontoFormBasicProps, "onFinish"> {
    buttoCencelar?: ReactElement;
    onCancelar?: (evento: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSuccess?:(response:AxiosResponse<void, any>, input:InscricaoDesconto) => void;
}
export default function InscricaoDescontoForm({
    buttoCencelar,
    onCancelar,
    onSuccess,
    ...props
}:IInscricaoDescontoFormProps) {
    const refForm = useRef<IInscricaoDescontoFormBasicRef|null>(null);

    const {
        mutate,
        isPending
    } = useInscricaoDescontoSalvar({
        onSuccess(data, variables) {
            onSuccess?.(data, variables);
            onCancelar?.({} as any);
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Desconto salvo com sucesso."
            });
        },
    });

    return <>
        <InscricaoDescontoFormBasic 
            {...props}
            ref={refForm}
            onFinish={(data) => {
                mutate(data.inscricaoDesconto);
            }}
        />
        
        <Divider />

        <Flex gap="small" wrap="wrap" justify="center">
            {!!buttoCencelar && buttoCencelar}
            {!!!buttoCencelar && !!onCancelar && (
                <Button type="primary" danger htmlType="reset" onClick={onCancelar}>
                    Cancelar
                </Button>
            )}
            <Button type="primary" onClick={() => refForm.current?.submit()} loading={isPending}>
                Salvar
            </Button>
        </Flex>
    </>;
}